<template>
  <b-card class="bg-white rounded-xl">
    <!-- <AddNewsPopup :isOpen="isPopupOpen" @close="togglePopup" /> -->
    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">List of Events</h2>

        <small class="text-muted">Manage all your events here. </small>
      </div>

      <base-button
        outline
        class="px-6 py-1 mx-1"
        type="primary"
        @click="handleEvents"
      >
        <span class="btn-inner--text flex justify-between items-center"
          ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon> Create
          Events
        </span>
      </base-button>
      <div>
        <b-form-select v-model="typeFilter" class="mx-1">
          <b-form-select-option :value="null"> </b-form-select-option>
          <b-form-select-option
            v-for="(i, index) in typeFilterOptions"
            :value="i"
            :key="index"
            >{{ i }}</b-form-select-option
          >
        </b-form-select>
      </div>
    </div>
    <EventsTable :typeFilter="typeFilter" />
  </b-card>
</template>

<script>
import EventsTable from "./components/EventsTable.vue";

import { mapState } from "vuex";

export default {
  data() {
    return {
      isPopupOpen: false,
      path: "",

      typeFilter: "All",
      typeFilterOptions: ["All", "Corporate"],
    };
  },
  components: {
    EventsTable,
  },

  methods: {
    handleEvents() {
      this.$router.push({ name: "addEvents" });
    },
  },
  mounted() {
    this.path =
      this.$router.currentRoute.fullPath.split("/")[1] == "Corporate"
        ? this.$router.currentRoute.fullPath.split("/")[1]
        : "";
    console.log(this.path, "PATH");
  },
};
</script>
